import React, { useState } from "react";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import Header from "../components/Header";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
 const [menuOpen, setMenuOpen] =  useState(false);
  return (
        <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />
              <Header />

      {/* Breadcrumb */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-1.jpg')",
                backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
          }}
        >
          <img
            src="assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
            
          />

          <div className="container">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">Sign In</h1>

                <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <a  href="javascript:void(0)">HOME</a>
                  </li>

                  <li>
Sign In</li>
                </ul>
              </div>
            </div>
          </div>
       
        </div>
    <section className="space-top space-extra-bottom">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-8">
            <div className="login-card">
              <div className="login-card__head text-center mb-4">
                <h2 className="login-card__title">Welcome Back</h2>
                <p className="login-card__sub">
                  Sign in to your Ninesister account
                </p>
              </div>

              {/* Social Login */}
         <div className="social-login mb-4">
  <a href="#" className="social-btn google-btn">
    <i className="fa-brands fa-google"></i>
    Continue with Google
  </a>

  <a href="#" className="social-btn facebook-btn">
    <i className="fa-brands fa-facebook-f"></i>
    Continue with Facebook
  </a>
</div>

              <div className="divider-text">
                <span>or sign in with email</span>
              </div>

              {/* Login Form */}
              <form className="login-form mt-4">
                <div className="form-group mb-3">
                  <label className="form-label">Email Address</label>

                  <input
                    type="email"
                    className="form-control"
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="form-label d-flex justify-content-between">
                    Password

                    <a href="/ForgotPassword" className="forgot-link">
                      Forgot password?
                    </a>
                  </label>

                  <div className="input-password-wrap">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="••••••••"
                      required
                    />

                  <button
  type="button"
  className="toggle-pwd"
  onClick={() => setShowPassword(!showPassword)}
>
  <i
    className={
      showPassword
        ? "fa-regular fa-eye"
        : "fa-regular fa-eye-slash"
    }
  ></i>
</button>
                  </div>
                </div>

                <div className="form-check mb-4">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="rememberMe"
                  />

                  <label
                    className="form-check-label"
                    htmlFor="rememberMe"
                  >
                    Remember me
                  </label>
                </div>

                <button type="submit" className="vs-btn w-100">
                  Sign In
                </button>
              </form>

              <p className="text-center mt-4 login-card__footer">
                Don't have an account?{" "}
                <a href="/Signup" className="auth-link">
                  Create one
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Login;